// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 76 ? "actioncable" : chunkId) + "-" + {"76":"7f2e1b36c93106602ef8","559":"837de19b2bbf83e79e9d"}[chunkId] + ".chunk.js";
};